import {createContext} from "react"

const ViewerContext=createContext({})

export default ViewerContext